import * as types from './types';

const initialState = {
  info: {
    name: '',
    lastName: '',
    email: '',
    phone: '',
    isSeeker: false,
    publisherTypeId: '',
    isIntegrator: false,
    lockedSoft: false,
    lockedManual: false,
    isAssistant: true,
    premier: false,
    urlLogo: null,
    isVAPublisher: false,
    hasAcceptedTermsAndconditions: false,
    appliesToI24Full: false,
    hasConfirmedContactData: false
  },
  fetched: false,
  loading: true,
  fetchedAcceptTermsAndConditions: false,
  errorAcceptTermsAndConditions: false,
  userFromApp: false,
  showLogin: false
};

function userInfoReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USER_INFO:
      return { ...state, loading: true, fetched: true };

    case types.FETCH_USER_INFO_COMPLETED:
      return {
        ...state,
        loading: false,
        info: { ...action.payload },
        fetchUserInfoError: false,
        fetched: true
      };

    case types.FETCH_USER_INFO_FAILED:
      return { ...state, loading: false, fetchUserInfoError: true, fetched: true };

    case types.MASK_USER:
      return {
        ...state,
        info: {
          ...state.info,
          isSeeker: true,
          publisherTypeId: null,
          showTasador: false,
          isIntegrador: false,
          isIntegrator: false,
          isPublisherMasked: true,
          maskChecked: true
        }
      };

    case types.NOT_MASK_USER:
      return {
        ...state,
        info: {
          ...state.info,
          maskChecked: true,
          isPublisherMasked: false
        }
      };

    case types.ACCEPT_TERMS_CONDITIONS:
      return { ...state };

    case types.ACCEPT_TERMS_CONDITIONS_COMPLETED:
      return {
        ...state,
        fetchedAcceptTermsAndConditions: true
      };

    case types.ACCEPT_TERMS_CONDITIONS_FAILED:
      return { ...state, errorAcceptTermsAndConditions: true };

    case types.USER_FROM_APP:
      return { ...state, userFromApp: true };

    case types.SHOW_LOGIN:
      return { ...state, showLogin: action.meta.status };

    default:
      return state;
  }
}

export default userInfoReducer;
